
// Enable JS className
document.documentElement.classList.add('has-js');

// Enable hover(), focus() and hover-and-focus() mixins
document.documentElement.classList.add(('ontouchstart' in window) ? 'touch' : 'no-touch');

// Enable Edge classNames (is-edge)
const edge = window.navigator.userAgent.indexOf('Edge');

if (edge !== -1) {
  document.documentElement.classList.add('is-edge');

  const version = parseInt(window.navigator.userAgent.substring(edge + 5, window.navigator.userAgent.indexOf('.', edge)), 10);

  if (version) {
    document.documentElement.classList.add('is-edge' + version);
  }
}

// Enable IE classNames (is-ie, is-ie9, is-ie10, is-ie11)
if (document.documentMode) {
  document.documentElement.classList.add('is-ie');
  document.documentElement.classList.add('is-ie' + document.documentMode);
}

// Enable iOS classnames (is-ipad, is-iphone, is-ios)
if (navigator.userAgent.match(/(iPad)/gi)) {
  document.documentElement.classList.add('is-ipad');
  document.documentElement.classList.add('is-ios');
} else if (navigator.userAgent.match(/(iPhone)/gi)) {
  document.documentElement.classList.add('is-iphone');
  document.documentElement.classList.add('is-ios');
}

// Enable OS classnames (is-osx, is-windows)
if (navigator.userAgent.match(/(Mac OS X)/gi)) {
  document.documentElement.classList.add('is-osx');
} else if (navigator.userAgent.match(/(Windows)/gi)) {
  document.documentElement.classList.add('is-windows');
}

// Enable Android classNames (is-android)
if (navigator.userAgent.match(/(Android)/gi)) {
  document.documentElement.classList.add('is-android');
}
